import React from "react";

import axios from "axios";
import Swal from "sweetalert2";

import Moment from "react-moment";

import config from "../../config";
import TablePagination from "@mui/material/TablePagination";
import { useNetworkState } from "react-use";
import Footer from "./Footer";
import Header from "./Header";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css"; // Import daterangepicker CSS
import "daterangepicker";
import * as XLSX from "xlsx";

const Billing_shipping_charges = () => {
  let userDetail = localStorage.getItem("ship_rocket_user");
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }
  const isOnline = useNetworkState();
  console.log("isONline  === ", isOnline);
  const [state, setState] = React.useState([]);
  const [loading, setloading] = React.useState(true);
  const [searchtext, setsearchtext] = React.useState(null);

  const [otherStates, setOtherState] = React.useState({
    dstatus: "",
    activePage: 1,
    rowsPerPage: 100,
    page: 0,
    total_count: 0,
    onload: true,
  });
  const [date, setdate] = React.useState({
    from_date: moment().subtract(30, "days").format("YYYY-MM-DD"),
    to_date: moment().format("YYYY-MM-DD"),
  });
  const [dateRange, setDateRange] = React.useState({
    startDate: moment().startOf("day"), // Default start date
    endDate: moment().startOf("day"), // Default end date
  });
  React.useEffect(() => {
    // Set the date range dynamically based on fetchedDays
    let dataToSend = {};
    let url = config.apiUrl + "/user/system_preferences_fetch";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((response) => {
        const data = response.data;
        console.log("response.data ==", response.data);
        if (response.data != null) {
          if (data.orderDateRange === "7 Days") {
            setDateRange({
              startDate: moment().subtract(7, "days").startOf("day"),
              endDate: moment().startOf("day"),
            });
          } else if (data.orderDateRange === "30 Days") {
            setDateRange({
              startDate: moment().subtract(30, "days").startOf("day"),
              endDate: moment().startOf("day"),
            });
          } else if (data.orderDateRange === "Today") {
            setDateRange({
              startDate: moment().startOf("day"),
              endDate: moment().startOf("day"),
            });
          }
        } else {
          setDateRange({
            startDate: moment().subtract(30, "days").startOf("day"),
            endDate: moment().startOf("day"),
          });
        }
      });
  }, []);
  React.useEffect(() => {
    list(0, true);
  }, [otherStates.rowsPerPage, date.from_date, date.to_date, searchtext]);

  const list = (index = 0, onLoad) => {
    let dataToSend = {
      customer_id: userData.customer_id,
      limit: otherStates.rowsPerPage,
      indexValue: index,
    };
    if (date.from_date != "") {
      dataToSend.from_date = date.from_date;
    }
    if (date.to_date != "") {
      dataToSend.to_date = date.to_date;
    }

    if (searchtext != null) {
      dataToSend.search = searchtext;
    }

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/user/shipping_charges_transaction";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        if (res.data.status == true) {
          if (onLoad) {
            setOtherState({
              ...otherStates,
              total_count: res.data.count,
              page: index,
            });
          }
          setState(res.data.output);
          setloading(false);
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#a61c09",
            type: "Unsuccess",
            title: "Something Went Wrong !",
            color: "white",
          });
        }
      })

      .catch((error) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#a61c09",
          type: "Unsuccess",
          title: "Something Went Wrong !",
          color: "white",
        });
        // console.log(error);
      });
  };

  const handlePageChange = (event, newPage) => {
    setOtherState({ ...otherStates, page: newPage });
    // console.log("newPage ", newPage);
    // getCountryList(newPage);
    list(newPage, true);
  };
  const handleChangeRowsPerPage = (event, newPage) => {
    // console.log("event ", event.target.value);
    setOtherState({ ...otherStates, rowsPerPage: event.target.value });
  };

  const dateselect = (start, end) => {
    setdate({
      ...date,
      from_date: moment(start).format("YYYY-MM-DD"),
      to_date: moment(end).format("YYYY-MM-DD"),
    });
  };
  React.useEffect(() => {
    const $picker = $(".custom-daterange");

    $picker.daterangepicker(
      {
        opens: "right",
        startDate: dateRange.startDate.format("YYYY-MM-DD"),
        endDate: dateRange.endDate.format("YYYY-MM-DD"),
        autoUpdateInput: true,
        locale: {
          format: "YYYY-MM-DD",
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "This Week": [moment().startOf("week"), moment().endOf("week")],
          "Last Week": [
            moment().subtract(1, "week").startOf("week"),
            moment().subtract(1, "week").endOf("week"),
          ],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
          "Last 3 Months": [
            moment().subtract(3, "months").startOf("month"),
            moment().endOf("month"),
          ],
          "This Year": [moment().startOf("year"), moment()],
        },
      },
      (start, end) => {
        // update input value
        $picker.val(
          `${start.format("YYYY-MM-DD")} to ${end.format("YYYY-MM-DD")}`
        );
        dateselect(start, end);
      }
    );

    // set default text
    $picker.val(
      `${dateRange.startDate.format(
        "YYYY-MM-DD"
      )} to ${dateRange.endDate.format("YYYY-MM-DD")}`
    );

    // cleanup
    return () => {
      $picker.data("daterangepicker").remove();
    };
  }, [dateRange]);

  const formatDataForSheet = (data) => {
    return data.map((item) => ({
      "Date/Time": new Date(item.created * 1000).toLocaleString(),
      Particulars: item.status == 6 ? "Refunded" : "Shipping Charges",
      Transaction: item.transaction_id,
      AWB: item.carrier_tracking_number,
      Credit:
        item.status == 6
          ? `₹ ${Number(item.total_amount || 0).toFixed(2)}`
          : "",
      Debit:
        item.status != 6 && item.status != 0
          ? `- ₹ ${Number(item.total_amount || 0).toFixed(2)}`
          : "",
    }));
  };

  const handleDownload = async () => {
    const workbook = XLSX.utils.book_new();

    const deductionData = state;
    const formattedDeductionData = formatDataForSheet(deductionData);
    const deductionSheet = XLSX.utils.json_to_sheet(formattedDeductionData);
    XLSX.utils.book_append_sheet(workbook, deductionSheet, "Shipping Charges");

    XLSX.writeFile(workbook, "Shipping_Charges.xlsx");
  };
  return (
    <div>
      {/* <?php $bodyClass = 'pg-legacy'; ?>
<?php  include('head_meta.php');  ?>
<?php  include('header.php');  ?> */}

      <Header>
        <div className="content">
          <div class="mob_nav">
            <div class="row">
              <div class="col">
                <div class=" d-flex justify-content-start ">
                  <a href="javascript:window.history.back();" class="">
                    <i class="bi bi-arrow-left"></i>
                  </a>
                  <h2>Shipping Charges</h2>
                </div>
              </div>
            </div>
          </div>

          <div class="row justify-content-between desk_nav">
            <div class="col-12 col-md-4 ">
              <div class="d-flex">
                <a href="javascript:window.history.back();" class="back_btn">
                  <i class="bi bi-arrow-90deg-left"></i>
                </a>
                <h2>Shipping Charges</h2>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-3"></div>
          </div>

          <div class="card mb-3">
            <div class="card-body">
              <div class="row justify-content-between">
                <div class="col-12 col-md-6 mb-1">
                  <div class="row g-1">
                    <div class="col-12 col-md-6">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control custom-daterange"
                        />
                        <span class="input-group-text">
                          <i class="bi bi-calendar2-range"></i>
                        </span>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="search-box">
                        <div class="search-icon">
                          <i class="bi bi-search"></i>
                        </div>
                        <input
                          type="text"
                          class="search-input"
                          placeholder="Search ..."
                          onChange={(e) => setsearchtext(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 mb-1">
                  <div class="row justify-content-between">
                    {/* <div class="col-6 col-md">
                <div class="row">
                    <div class="col-12 col-md">
                      <a href="" class="btn btn-outline-secondary btn-block">View Report</a>
                    </div>
                </div>
              </div> */}
                    <div class="col-6 col-md-4 text-end">
                      <a
                        class="btn btn-outline-secondary btn-block"
                        onClick={(e) => handleDownload(e)}
                      >
                        Download Report
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card data_table mb-3 ">
            <div class="card-body">
              <div class="table-responsive">
                <div class="shipm_tablew rounded-3">
                  <table class="table align-top table-striped table-hover m-0 table-xl ">
                    <thead>
                      <tr>
                        <th width="170px">Date</th>
                        <th width="140px">Transaction ID</th>
                        {/* <th width="">Order Number</th> */}
                        <th width="200px">AWB Number</th>
                        <th>Weight & Zone</th>
                        <th>Carrier</th>
                        <th>Particluars</th>
                        <th>Credit</th>
                        <th>Debit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {state.length > 0 ? (
                        state.map((sub) => (
                          <tr class="">
                            <td>
                              <small>
                                <Moment format="MMM DD YYYY">
                                  {new Date(sub.created * 1000)}
                                </Moment>{" "}
                                -{" "}
                                <Moment format="hh:mm:ss a">
                                  {new Date(sub.created * 1000)}
                                </Moment>
                              </small>
                            </td>
                            <td>
                              <a href="#" class="text-primary">
                                {sub.transaction_id}
                              </a>
                            </td>
                            {/* <td>
                <h6><a href="#" class="text-primary">1724228987370</a></h6>
              </td> */}
                            <td>
                              <h6>
                                <a href="#" class="text-primary">
                                  {" "}
                                  {sub.carrier_tracking_number}
                                </a>
                              </h6>
                            </td>
                            <td>
                              {sub.total_weight} KG
                              <small>
                                {" "}
                                {sub.zone_name ? sub.zone_name : ""}
                              </small>
                            </td>
                            <td>{sub.service_provider}</td>
                            <td>
                              {sub.status == 6
                                ? "Refunded"
                                : "Shipping Charges"}
                            </td>
                            <td>
                              <span class="text-success">
                                {sub.status == 6 ? (
                                  <>
                                    ₹ {Number(sub.total_amount || 0).toFixed(2)}
                                  </>
                                ) : (
                                  ""
                                )}
                              </span>
                            </td>
                            <td>
                              <span class="text-danger">
                                {sub.status != 6 && sub.status != 0 ? (
                                  <>
                                    - ₹{" "}
                                    {Number(sub.total_amount || 0).toFixed(2)}
                                  </>
                                ) : (
                                  ""
                                )}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colspan="12" class="text-center">
                            Sorry! There is no data available at the moment.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <TablePagination
            component="div"
            rowsPerPageOptions={[
              100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
            ]}
            count={otherStates.total_count}
            page={otherStates.page}
            onPageChange={handlePageChange}
            rowsPerPage={otherStates.rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Billing_shipping_charges;
